import React, { useState } from 'react';
export const Spotlight = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    organization: '',
    socialMedia: '',
    bio: '',
    mission: '',
    inspiration: '',
    problem: '',
    impact: '',
    experience: '',
    moment: '',
    collaborations: '',
    influences: '',
    advice: '',
    photoLinks: '',
    logoLink: '',
    consent: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    try {
      // Prepare data for Google Sheet
      const submissionData = {
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        location: formData.location,
        role: formData.role,
        organization: formData.organization,
        socialMedia: formData.socialMedia,
        bio: formData.bio,
        mission: formData.mission,
        inspiration: formData.inspiration,
        problem: formData.problem,
        impact: formData.impact,
        experience: formData.experience,
        moment: formData.moment,
        collaborations: formData.collaborations,
        influences: formData.influences,
        advice: formData.advice,
        photoLinks: formData.photoLinks,
        logoLink: formData.logoLink,
        consent: formData.consent,
        submittedAt: new Date().toISOString()
      };
      console.log('Submitting form to Google Sheet...');
      const response = await fetch('https://script.google.com/macros/s/AKfycbx5J7CRh1JX7_9E-LHEQNz17oj77yzni2E8uTjT8uZ6qpjMnvQo_uS6ZdAE-dVLw6YeGw/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(submissionData)
      });
      // With no-cors mode, we can't read the response, but if no error was thrown, assume success
      console.log('Form submitted successfully');
      setIsSubmitted(true);
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        location: '',
        role: '',
        organization: '',
        socialMedia: '',
        bio: '',
        mission: '',
        inspiration: '',
        problem: '',
        impact: '',
        experience: '',
        moment: '',
        collaborations: '',
        influences: '',
        advice: '',
        photoLinks: '',
        logoLink: '',
        consent: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrorMessage('Network or server error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="pt-20 min-h-screen" data-id="element-4616">
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-4617">
        <div className="container mx-auto px-4" data-id="element-4618">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4619">
            <h1 className="text-4xl font-bold mb-6 text-gray-800" data-id="element-4620">
              ✨ The Salon Spotlight
            </h1>
            <p className="text-gray-600 mb-4" data-id="element-4621">
              We're shining the light on remarkable people shaping culture in
              their own unique ways — creators, thinkers, innovators, builders,
              and dreamers who are pushing boundaries and making impact.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-4622">
              This feature is part of The Networking Salon's ongoing effort to
              celebrate individuals who are moving ideas, communities, and
              culture forward.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-4623">
              Please fill in the details below to help us tell your story
              beautifully.
            </p>
            <p className="text-gray-600 font-medium" data-id="element-4624">
              Short, honest, and heartfelt responses are best.
            </p>
          </div>
        </div>
      </section>
      <section className="py-12" data-id="element-4625">
        <div className="container mx-auto px-4" data-id="element-4626">
          <div className="max-w-3xl mx-auto" data-id="element-4627">
            {isSubmitted ? <div className="text-center py-16 px-6 border-2 border-gray-300 rounded-lg" data-id="element-4628">
                <h2 className="text-2xl font-bold mb-4 text-gray-800" data-id="element-4629">
                  Thank you for sharing your story with us!
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-4630">
                  Our team will review your submission and reach out when your
                  feature is scheduled.
                </p>
                <p className="text-gray-600 font-medium" data-id="element-4631">
                  Keep creating, building, and shaping the culture — the world
                  needs what you bring. 💫
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-10" data-id="element-4632">
                {errorMessage && <div className="bg-gray-100 border-2 border-gray-400 text-gray-800 p-4 rounded-md" data-id="element-4633">
                    <p className="font-medium" data-id="element-4634">Error submitting form:</p>
                    <p data-id="element-4635">{errorMessage}</p>
                  </div>}
                {/* SECTION 1: Personal Details */}
                <div className="space-y-6" data-id="element-4636">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4637">
                    SECTION 1: Personal Details
                  </h2>
                  <div className="space-y-4" data-id="element-4638">
                    <div data-id="element-4639">
                      <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-4640">
                        Full Name *
                      </label>
                      <input type="text" id="fullName" name="fullName" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4641" />
                    </div>
                    <div data-id="element-4642">
                      <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-4643">
                        Email Address *
                      </label>
                      <input type="email" id="email" name="email" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4644" />
                    </div>
                    <div data-id="element-4645">
                      <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-4646">
                        Phone Number (WhatsApp Preferred) *
                      </label>
                      <input type="tel" id="phone" name="phone" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4647" />
                    </div>
                    <div data-id="element-4648">
                      <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-4649">
                        City / Country *
                      </label>
                      <input type="text" id="location" name="location" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4650" />
                    </div>
                    <div data-id="element-4651">
                      <label htmlFor="role" className="block text-gray-700 font-medium mb-1" data-id="element-4652">
                        Role / Profession / Creative Focus *
                      </label>
                      <input type="text" id="role" name="role" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4653" />
                    </div>
                    <div data-id="element-4654">
                      <label htmlFor="organization" className="block text-gray-700 font-medium mb-1" data-id="element-4655">
                        Organization, Brand, or Project Name
                      </label>
                      <input type="text" id="organization" name="organization" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4656" />
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4657">Optional</p>
                    </div>
                    <div data-id="element-4658">
                      <label htmlFor="socialMedia" className="block text-gray-700 font-medium mb-1" data-id="element-4659">
                        Social Media Links (Please include any that apply)
                      </label>
                      <textarea id="socialMedia" name="socialMedia" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={5} placeholder="LinkedIn:
Instagram:
X (Twitter):
Website / Portfolio:" onChange={handleChange} data-id="element-4660"></textarea>
                    </div>
                    <div data-id="element-4661">
                      <label htmlFor="bio" className="block text-gray-700 font-medium mb-1" data-id="element-4662">
                        Short Bio (3–5 lines) *
                      </label>
                      <textarea id="bio" name="bio" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4663"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 2: Your Story */}
                <div className="space-y-6" data-id="element-4664">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4665">
                    SECTION 2: Your Story
                  </h2>
                  <div className="space-y-4" data-id="element-4666">
                    <div data-id="element-4667">
                      <label htmlFor="mission" className="block text-gray-700 font-medium mb-1" data-id="element-4668">
                        Tell us about what you do. What's your mission or
                        creative focus? *
                      </label>
                      <textarea id="mission" name="mission" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4669"></textarea>
                    </div>
                    <div data-id="element-4670">
                      <label htmlFor="inspiration" className="block text-gray-700 font-medium mb-1" data-id="element-4671">
                        What inspired you to start this journey? *
                      </label>
                      <textarea id="inspiration" name="inspiration" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4672"></textarea>
                    </div>
                    <div data-id="element-4673">
                      <label htmlFor="problem" className="block text-gray-700 font-medium mb-1" data-id="element-4674">
                        What problem are you trying to solve — or what change
                        are you hoping to make?
                      </label>
                      <textarea id="problem" name="problem" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4675"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4676">Optional</p>
                    </div>
                  </div>
                </div>
                {/* SECTION 3: Culture & Impact */}
                <div className="space-y-6" data-id="element-4677">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4678">
                    SECTION 3: Culture & Impact
                  </h2>
                  <div className="space-y-4" data-id="element-4679">
                    <div data-id="element-4680">
                      <label htmlFor="impact" className="block text-gray-700 font-medium mb-1" data-id="element-4681">
                        How do you think your work contributes to shaping
                        culture or your community? *
                      </label>
                      <textarea id="impact" name="impact" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4682"></textarea>
                    </div>
                    <div data-id="element-4683">
                      <label htmlFor="experience" className="block text-gray-700 font-medium mb-1" data-id="element-4684">
                        What do you want people to feel or experience through
                        what you do?
                      </label>
                      <textarea id="experience" name="experience" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4685"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4686">Optional</p>
                    </div>
                    <div data-id="element-4687">
                      <label htmlFor="moment" className="block text-gray-700 font-medium mb-1" data-id="element-4688">
                        Share one moment that reminded you your work matters. *
                      </label>
                      <textarea id="moment" name="moment" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4689"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 4: Connection & Inspiration */}
                <div className="space-y-6" data-id="element-4690">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4691">
                    SECTION 4: Connection & Inspiration
                  </h2>
                  <div className="space-y-4" data-id="element-4692">
                    <div data-id="element-4693">
                      <label htmlFor="collaborations" className="block text-gray-700 font-medium mb-1" data-id="element-4694">
                        What kind of collaborations or opportunities are you
                        open to right now?
                      </label>
                      <textarea id="collaborations" name="collaborations" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4695"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4696">Optional</p>
                    </div>
                    <div data-id="element-4697">
                      <label htmlFor="influences" className="block text-gray-700 font-medium mb-1" data-id="element-4698">
                        Who or what influences your work the most? *
                      </label>
                      <textarea id="influences" name="influences" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4699"></textarea>
                    </div>
                    <div data-id="element-4700">
                      <label htmlFor="advice" className="block text-gray-700 font-medium mb-1" data-id="element-4701">
                        What advice would you give to other young people trying
                        to build something meaningful? *
                      </label>
                      <textarea id="advice" name="advice" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4702"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 5: Visuals */}
                <div className="space-y-6" data-id="element-4703">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4704">
                    SECTION 5: Visuals
                  </h2>
                  <div className="space-y-4" data-id="element-4705">
                    <div data-id="element-4706">
                      <label htmlFor="photoLinks" className="block text-gray-700 font-medium mb-1" data-id="element-4707">
                        Links to 1–2 photos (portrait or action shots) *
                      </label>
                      <textarea id="photoLinks" name="photoLinks" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={3} placeholder="Paste Google Drive, Dropbox, or other image links here. One link per line." onChange={handleChange} data-id="element-4708"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4709">
                        Please provide publicly accessible links to your photos
                        (Google Drive, Dropbox, etc.)
                      </p>
                    </div>
                    <div data-id="element-4710">
                      <label htmlFor="logoLink" className="block text-gray-700 font-medium mb-1" data-id="element-4711">
                        Optional: Link to your logo or brand image
                      </label>
                      <input type="url" id="logoLink" name="logoLink" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" placeholder="https://example.com/your-logo.png" onChange={handleChange} data-id="element-4712" />
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4713">
                        Optional. Paste a link to your logo or brand image.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Final Consent */}
                <div className="space-y-6" data-id="element-4714">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4715">
                    Final Consent
                  </h2>
                  <div data-id="element-4716">
                    <p className="block text-gray-700 font-medium mb-2" data-id="element-4717">
                      Do you give The Networking Salon permission to feature
                      your story, photos, and content (with credit) across its
                      digital platforms and media? *
                    </p>
                    <div className="space-y-2" data-id="element-4718">
                      <label className="flex items-center" data-id="element-4719">
                        <input type="radio" name="consent" value="Yes, I do" required className="mr-2 h-5 w-5" onChange={handleChange} data-id="element-4720" />
                        <span className="text-gray-700" data-id="element-4721">Yes, I do</span>
                      </label>
                      <label className="flex items-center" data-id="element-4722">
                        <input type="radio" name="consent" value="I'd like to review my feature before it's published (T&C Apply)" className="mr-2 h-5 w-5" onChange={handleChange} data-id="element-4723" />
                        <span className="text-gray-700" data-id="element-4724">
                          I'd like to review my feature before it's published
                          (T&C Apply)
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                {/* Submit Button */}
                <div className="pt-4" data-id="element-4725">
                  <button type="submit" disabled={isSubmitting} className="w-full py-3 px-6 bg-gray-800 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 disabled:opacity-70" data-id="element-4726">
                    {isSubmitting ? 'Submitting...' : 'Submit Your Story'}
                  </button>
                </div>
              </form>}
          </div>
        </div>
      </section>
    </div>;
};